function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgFileImage(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#000400",
    d: "M21.224 4c.447 0 .776.298.776.702v14.596c0 .404-.33.702-.776.702H2.776C2.33 20 2 19.702 2 19.298V4.702C2 4.298 2.33 4 2.776 4h18.448zM20 6H4v12h16V6zm-4.725 4.11a1 1 0 01.318.36l3.025 5.799a.5.5 0 01-.443.731H5.96a.5.5 0 01-.41-.787l2.21-3.16a1 1 0 011.638-.001l1.326 1.887 3.16-4.575a1 1 0 011.391-.254zM8.5 8c.85 0 1.5.7 1.5 1.5 0 .875-.7 1.5-1.5 1.5S7.05 10.35 7 9.5C7 8.65 7.7 8 8.5 8z"
  }));
}

SvgFileImage.clsName = 'icon-www__file-image';
SvgFileImage.remarkName = 'unknown';
export default SvgFileImage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/FileImage.js
// module id = 2345
// module chunks = 17 18